var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSync = function SvgSync(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "syncIcon",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgSync{fill:#B5B5B5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "change_1_",
    className: "svgSync svgBase svgHover svgSelect",
    d: "M8,15.7c-0.9,0-1.9-0.2-2.8-0.5c-0.3-0.1-0.4-0.5-0.3-0.8c0.1-0.3,0.4-0.4,0.7-0.3 c3.4,1.3,7.2-0.4,8.5-3.8c0.7-1.8,0.6-3.8-0.4-5.5l-0.9,1.6c-0.2,0.3-0.5,0.4-0.8,0.2c-0.3-0.2-0.4-0.5-0.2-0.8c0,0,0,0,0,0l1.4-2.4 c0.2-0.3,0.5-0.4,0.8-0.2c0.1,0,0.1,0.1,0.2,0.2c2.5,3.4,1.8,8.3-1.7,10.8C11.2,15.2,9.6,15.7,8,15.7 M2.7,13.4 c-0.2,0-0.3-0.1-0.4-0.2C-0.6,10-0.3,5.1,2.8,2.3c2-1.8,4.8-2.4,7.3-1.7c0.3,0.1,0.5,0.4,0.4,0.7c-0.1,0.3-0.4,0.5-0.7,0.4 c-3.5-1-7.2,1-8.2,4.5c-0.6,1.9-0.2,4,1,5.7l1.2-1.9C4,9.7,4.4,9.6,4.6,9.8c0.3,0.2,0.3,0.5,0.2,0.8l-1.6,2.6 C3.1,13.3,2.9,13.4,2.7,13.4L2.7,13.4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSync, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sync.2522d540.svg";
export { ForwardRef as ReactComponent };